import { Component, Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { EMPTY, from, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { environment } from 'environments/environment';

import { TranslateService } from '@ngx-translate/core';

import { AuthService } from 'app/services/auth.service';
import { ToastService } from '../../services/toast.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    private translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    private toast: ToastService,
    public dialog: MatDialog
  ) {
  }

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(req)
      .pipe(
        catchError(response => {
          if (response.error instanceof Blob) {
            return from(response.error.text()).pipe(switchMap(x => {
              response.error = JSON.parse(x.toString());
              return throwError(response);
            }
            ));
          } else {
            return throwError(response);
          }
        }),
        catchError(response => {

          const error = { status: response.status, error: response, 
            errorcode: response.error.ErrorCode || this.translate.instant('errors.ErrUnknown'), errors: response.error.errors };
          try {
            if (response.status === 0) {
              if (response.url === null) {
                error.errorcode = this.translate.instant('errors.ErrServerUnavailable');
                this.toast.error(error.errorcode);
                return throwError(error);
              } else {
                this.router.navigate(['/error'], { queryParams: { errorMessage: response.message } });
                return EMPTY;
              }
            } else if (response.status === 400 || response.status === 404 || response.status === 403) {
              if (response.error.ErrorCode !== 'ErrPasswordNotValid') {
                if (!response.error.Errors?.length) {
                  this.toast.success(this.translate.instant('errors.' + response.error.ErrorCode));
                } else {
                  let errorsArray = [];
                  for (let i = 0; i < response.error.Errors.length; i++) {
                    const msgSplit: string[] = response.error.Errors[i].split('|');
                    let param = {}
                    let count = 0
                    msgSplit.forEach(msg => {
                      if (count != 0) {
                        param[`param${count}`] = msg;
                        count++
                      } else {
                        count++
                      }
                    });
                    errorsArray.push({
                      key: `ERROR_FORM.${msgSplit[0]}`,
                      param: param
                    })

                  }
                  const dialogRef = this.dialog.open(ErrorMessagesModal, {
                    width: '400px',
                    data: errorsArray,
                  });
                }
              }
            } else if (response.status === 401) {
              this.authService.enforceLogin(
                error.error.err === undefined ?
                  (!error.error.error ? '' : error.error.error.ErrorCode) :
                  error.error.err
              );
              return EMPTY;
            } else if (response.status >= 500) {
              if (environment.redirectOnInternalServerError) {
                this.router.navigate(['/error'], { queryParams: { errorMessage: response.error.Details } });
                return EMPTY;
              }
              this.toast.error(error.errorcode);
            }
            return throwError(error);
          } catch (ex) {
            // Log Ex
            error.errorcode = this.translate.instant('errors.ErrUnexpected');
            this.toast.error(error.errorcode);
            return throwError(error);
          }
        })
      );
  }
}
@Component({
  selector: 'dialog-overview-example-dialog',
  template: `<div>
                <h1 style="text-align: center">{{warning}}</h1>
                <div *ngFor="let error of data">
                    <p>{{ error.key | translate :  error.param }}</p>
                    
                </div>
             </div>`

})
export class ErrorMessagesModal {

  warning = '';
  constructor(
    public dialogRef: MatDialogRef<ErrorMessagesModal>,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    private translate: TranslateService,
  ) {
    this.warning = this.translate.instant("ALERT_DIALOG.TITLE");
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}